/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("StartMenuGroupController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class StartMenuGroupController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class StartMenuGroupController extends cls.ControllerBase /** @lends classes.StartMenuGroupController.prototype */ {
    static __name = "StartMenuGroupController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.FontStyle4STBehavior);
      this._addBehavior(cls.FontSize4STBehavior);
      this._addBehavior(cls.FontColor4STBehavior);
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.DisabledVMBehavior);
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      this._addBehavior(cls.TextVMBehavior);
      this._addBehavior(cls.ImageVMBehavior);
    }

    _getWidgetType(kind) {
      const parent = this.getAnchorNode().getAncestor("StartMenu");
      let type = null;
      if (parent) {
        type = parent.getController()._getWidgetType(kind) + "Group";
      }
      return type;
    }
  }

  cls.StartMenuGroupController = StartMenuGroupController;
  cls.ControllerFactory.register("StartMenuGroup", cls.StartMenuGroupController);
});
